import { render, staticRenderFns } from "./VisitorSocialBans.vue?vue&type=template&id=6b1bb658&"
import script from "./VisitorSocialBans.vue?vue&type=script&lang=js&"
export * from "./VisitorSocialBans.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports